import { extendObservable, computed, action } from 'mobx';
import FeedbackChain from '../models/FeedbackChain';
import axios from '../../../libs/axios_csrf';
import { snakeCase, camelCase } from '@ridi/object-case-converter';
import { safeMomentDate } from '../models/functions';

export default class FeedbackChainsStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    extendObservable(this, {
      chains: [],
      filter: FeedbackChain.filters.ALL_NOT_DONE,
      pageSize: 10,
      currentFeedbackChain: null,
      currentFeedbackChainIndex: null,
      loading: false,
    });
  }

  get feedbackParticipantsStore() {
    return this.rootStore.feedbackParticipantsStore;
  }

  get feedbackCommentsStore() {
    return this.rootStore.feedbackCommentsStore;
  }

  get attachmentsStore() {
    return this.rootStore.attachmentsStore;
  }

  loadData(feedbackChains) {
    if (feedbackChains != undefined) {
      for (const feedbackChain of feedbackChains) {
        const newFeedbackChain = FeedbackChain.deserialize(feedbackChain, this);
        newFeedbackChain.id = feedbackChain.id;
        this.chains.push(newFeedbackChain);
      }
    }
  }

  destroy(feedbackChain) {
    this.destroyBackend(feedbackChain);
    this.chains.remove(feedbackChain);
    feedbackChain.dispose();
  }

  getFeedbackById(chainId) {
    //Looking for the chain in Stores
    let c = this.chains.find(feedbackChain => {
      return feedbackChain.id == chainId;
    });

    if (c == undefined) {
      //c= this.lookForChainBackend(chainId);
    }
    return c;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // FEEDBACK CHAINS TABLE
  @action
  filterByView(viewType) {
    this.filter = viewType;
  }

  @action
  pageSizePreference(size) {
    this.pageSize = size;
  }

  @action
  setCurrentFeedbackChain(feedbackChain) {
    this.currentFeedbackChain = this.getFeedbackById(feedbackChain.id);
    const filteredFeedbacks = this.filteredFeedbackChains;
    this.currentFeedbackChainIndex = filteredFeedbacks.indexOf(
      this.currentFeedbackChain,
    );
  }

  move(direction) {
    const length = this.filteredFeedbackChains.length;
    const next = this.currentFeedbackChainIndex + 1;
    const prev = this.currentFeedbackChainIndex - 1;

    if (length === next && direction === 1)
      return { id: this.currentFeedbackChain.id, disabled: true };

    if (prev < 0 && direction === 0) {
      return { id: this.currentFeedbackChain.id, disabled: true };
    }

    return direction === 1
      ? { id: this.filteredFeedbackChains[next].id, disabled: false }
      : { id: this.filteredFeedbackChains[prev].id, disabled: false };
  }

  @computed
  get pageSize() {
    return this.pageSize;
  }

  @computed
  get filteredFeedbackChains() {
    return this.feedbacksByFilter(this.filter);
  }

  feedbacksByFilter(filter) {
    return this.chains.filter(fc => fc.meetsFilters(filter));
  }

  @computed get feedbackChains() {
    return this.chains.filter(
      feedbackChain => feedbackChain.category == 'feedback',
    );
  }

  @computed get internalChains() {
    return this.chains.filter(
      feedbackChain => feedbackChain.category == 'internal',
    );
  }

  @computed get supportChains() {
    return this.chains.filter(
      feedbackChain => feedbackChain.category == 'support',
    );
  }

  @computed get issueChains() {
    return this.chains.filter(
      feedbackChain => feedbackChain.category == 'issues',
    );
  }
  // end FEEDBACK CHAINS TABLE
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // BACKEND CONNECTIONS
  @action
  fetchData(nextPage = 1) {
    this.loading = true;
    axios
      .get('/gstartup/' + this.rootStore.startupId + '/feedback_chains.json', {
        params: {
          page: nextPage,
        },
      })
      .then(
        action(response => {
          this.loadData(camelCase(response.data.feedback_chains, true));
          this.loading = false;
          if (response.data.next_page) {
            this.fetchData(response.data.next_page);
          }
        }),
      )
      .catch(
        action(function(error) {
          console.log(error);
          this.loading = false;
        }),
      );
  }

  @action
  updateBackend(feedbackChain) {
    feedbackChain.setUpdating(true);
    axios
      .patch('/feedback_chains/' + feedbackChain.id + '.json', {
        feedback_chain: snakeCase(feedbackChain.serialize(), true),
      })
      .then(
        action(response => {
          const json = camelCase(
            JSON.parse(response.data.feedback_chain),
            true,
          );
          feedbackChain.setUpdating(false);
          feedbackChain.updateFromJson(json);
          // Success message
        }),
      )
      .catch(
        action(errors => {
          feedbackChain.setUpdating(false);
          console.log(errors);
        }),
      );
  }

  @action
  destroyBackend(feedbackChain) {
    axios
      .delete('/feedback_chains/' + feedbackChain.id + '.json')
      .then(action(response => {}))
      .catch(
        action(errors => {
          console.log(errors);
        }),
      );
  }
  // end BACKEND CONNECTIONS
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
}
